import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"
import _imports_0 from '@/assets/themeThree/backbonus_multiple_bg3.png'


const _hoisted_1 = { class: "closeICon" }
const _hoisted_2 = { class: "treasureContainer" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "TitleText" }
const _hoisted_5 = { class: "giftImageContainer" }
const _hoisted_6 = { class: "textBar" }
const _hoisted_7 = { class: "claimedBtn_1" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = { class: "giftImageContainer" }
const _hoisted_10 = { class: "dataContent" }
const _hoisted_11 = { class: "title1" }
const _hoisted_12 = { class: "rewardText" }
const _hoisted_13 = {
  class: "claimedBtn",
  style: {"margin-top":"25%"}
}
const _hoisted_14 = { key: 2 }
const _hoisted_15 = { class: "content" }
const _hoisted_16 = { class: "contentTitle" }
const _hoisted_17 = {
  key: 0,
  class: "multipleTabel"
}
const _hoisted_18 = {
  key: 1,
  class: "dashLine"
}
const _hoisted_19 = { class: "bonusText" }
const _hoisted_20 = { class: "bonusText2" }

import { ref, onMounted } from 'vue';
import MainButton from '../components/common/mainButton.vue';
import LoadingScreen from '@/components/common/loadingScreen.vue';
import StatusPopup from '@/components/common/statusPopup.vue';
import { useRouter } from 'vue-router';
import { useReturnTreasureService } from '@/view/returnTreasure/supportScript';
import AnimatedGiftOne from '../dailyTreasure/components/animatedGiftOne.vue';
import AnimatedGifttwo from '../dailyTreasure/components/animatedGifttwo.vue';
import { useUserStore } from '@/stores/user';
import RainCoinOverlay from '@/components/common/rainCoinOverlay.vue';

export default /*@__PURE__*/_defineComponent({
  __name: 'returnTreasureView',
  emits: [ 'resetShowTreasurePopup'],
  setup(__props, { expose: __expose, emit: __emit }) {

const userStore = useUserStore()
const router = useRouter()
const show = ref(false)
const showPopIndex = ref(0)
const isSuccess = ref(false)
const toastContent = ref('')
const statusRef = ref()
const loadingRef = ref()
const rewardAmount = ref(0)
const rewardTimes = ref(0)
const rewardType = ref(1)
const fixedRechargeConfigs = ref<any>([])
const description = ref(JSON.parse(userStore.returnTreasure?.return_treasure_chest_reward.description))
const showError = (msg: string) => {
    toastContent.value = msg
    isSuccess.value = false
    statusRef.value.open()
}
const showSuccess = (msg: string) => {
    toastContent.value = msg
    isSuccess.value = true
    statusRef.value.open()
}

const { fetchRewardInfo, claimReward } = useReturnTreasureService(showError, showSuccess, loadingRef)
const emits = __emit
const goToClaimed = () => {

    getClaimReward()
}
const getClaimedInfo = () => {
    showPopIndex.value = 2
}
const openPopup = () => {
    show.value = true
}
const closePopup = () => {
    show.value = false
    localStorage.setItem('redirectFromCalim', '')
    emits('resetShowTreasurePopup')
}
const goToDeposit = () => {
    router.push({
        path: '/sd-topup',
        query: { type: 2 }
    })
    localStorage.setItem('showDepositBackIcon', '1')
}

const getClaimReward = async () => {
    const data = await fetchRewardInfo()
    rewardAmount.value = data.rewardAmount
    rewardTimes.value = data.rewardTimes
    showPopIndex.value = 1
    rewardType.value = data.rewardType
    fixedRechargeConfigs.value = data.fixedRechargeConfigs
}

const getClaim = async () => {
    await claimReward()
    setTimeout(() => closePopup(), 1500)
}
onMounted(() => {
    let timeSet = localStorage.getItem('redirectFromCalim')
    if (timeSet === 'true') {
        show.value = true
    } else {
        setTimeout(() => {
            show.value = true
        }, 3000)
    }
})
__expose({
    closePopup
})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!
  const _component_van_popup = _resolveComponent("van-popup")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (show.value && showPopIndex.value === 0)
      ? (_openBlock(), _createBlock(RainCoinOverlay, { key: 0 }))
      : _createCommentVNode("", true),
    _createVNode(_component_van_popup, {
      show: show.value,
      "onUpdate:show": _cache[0] || (_cache[0] = ($event: any) => ((show).value = $event)),
      position: "center",
      "overlay-style": { overflow: 'hidden' },
      style: {
        minWidth: '100%',
        background: 'transparent',
        color: '#fff',
        overflow: 'hidden',
        zIndex: '10000'
    }
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: _normalizeClass(show.value && showPopIndex.value === 0 ? '' : 'showBlurBackground')
        }, [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_van_icon, {
              name: "cross",
              onClick: closePopup,
              style: {"padding":"5px","background-color":"#709bbf82","border-radius":"30px"}
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            (showPopIndex.value === 0)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(userStore).returnTreasure?.return_treasure_chest_reward.header), 1),
                  _createElementVNode("div", _hoisted_5, [
                    _createVNode(AnimatedGiftOne),
                    _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(userStore).returnTreasure?.return_treasure_chest_reward.sub_header), 1)
                  ]),
                  _createElementVNode("div", _hoisted_7, [
                    _createVNode(MainButton, {
                      title: _ctx.$t('chest.open'),
                      "active-status": true,
                      onClick: goToClaimed
                    }, null, 8, ["title"])
                  ])
                ]))
              : _createCommentVNode("", true),
            (showPopIndex.value === 1)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(AnimatedGifttwo)
                  ]),
                  _createElementVNode("div", _hoisted_10, [
                    _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t('chest.ReceiveBonus')), 1),
                    _createElementVNode("div", _hoisted_12, "+R$ " + _toDisplayString(rewardAmount.value), 1),
                    _createElementVNode("div", _hoisted_13, [
                      _createVNode(MainButton, {
                        title: _ctx.$t('chest.Receive'),
                        "active-status": true,
                        onClick: getClaimedInfo
                      }, null, 8, ["title"])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            (showPopIndex.value === 2)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[1] || (_cache[1] = _createElementVNode("div", { class: "rewardDetails" }, [
                    _createElementVNode("img", {
                      src: _imports_0,
                      alt: ""
                    })
                  ], -1)),
                  _createElementVNode("div", _hoisted_15, [
                    _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.$t('chest.multiRewards')), 1),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(description.value, (i) => {
                      return (_openBlock(), _createElementBlock("div", {
                        class: "contentText",
                        key: i
                      }, _toDisplayString(i), 1))
                    }), 128)),
                    (rewardType.value == 2)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(fixedRechargeConfigs.value, (item, index) => {
                            return (_openBlock(), _createBlock(_component_van_row, {
                              key: index,
                              class: "timesRow"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_van_col, { span: "12" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.amount), 1)
                                  ]),
                                  _: 2
                                }, 1024),
                                _createVNode(_component_van_col, { span: "12" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(item.multiple) + "X", 1)
                                  ]),
                                  _: 2
                                }, 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                          _createElementVNode("div", _hoisted_19, _toDisplayString(rewardTimes.value + 'x'), 1),
                          _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$t('chest.timesBonus')), 1)
                        ]))
                  ]),
                  _createVNode(_component_van_row, { style: {"padding":"0 15px"} }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_col, {
                        span: "12",
                        style: {"padding":"0 10px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "cancelBtn",
                            onClick: getClaim
                          }, _toDisplayString(_ctx.$t('chest.keepClaming')), 1)
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_van_col, {
                        span: "12",
                        style: {"padding":"0 10px"}
                      }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", {
                            class: "depositBtn",
                            onClick: goToDeposit
                          }, _toDisplayString(_ctx.$t('chest.claimDoubleBonus')), 1)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(LoadingScreen, {
              ref_key: "loadingRef",
              ref: loadingRef
            }, null, 512),
            _createVNode(StatusPopup, {
              ref_key: "statusRef",
              ref: statusRef,
              "is-show-success": isSuccess.value,
              content: toastContent.value
            }, null, 8, ["is-show-success", "content"])
          ])
        ], 2)
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})